import React from 'react';
import { Form, Input, Button, message } from 'antd';
import type { FormProps } from 'antd';

const { TextArea } = Input;

interface ContactFormValues {
  name: string;
  email: string;
  message: string;
}

const ContactForm: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish: FormProps<ContactFormValues>['onFinish'] = (values) => {
    console.log('Form data:', values);
    // TODO: Implement form submission
    message.success('Thank you! Your message has been sent.');
    form.resetFields();
  };

  const onFinishFailed: FormProps<ContactFormValues>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Form
      form={form}
      name="contact"
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      size="large"
    >
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Please input your name!' }]}
      >
        <Input placeholder="Name" />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: 'Please input your email!' },
          { type: 'email', message: 'Please enter a valid email address!' }
        ]}
      >
        <Input placeholder="Email" />
      </Form.Item>

      <Form.Item
        label="Message"
        name="message"
        rules={[{ required: true, message: 'Please input your message!' }]}
      >
        <TextArea rows={4} placeholder="Message" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block>
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ContactForm;
